import { gql } from 'apollo-boost'

const MARK_DISH_REVIEW_TASK_MISC_AS_QC_VERIFIED = gql`
  mutation markDishReviewTaskMiscAsQCVerified($id: ID!, $comment: String) {
    markDishReviewTaskMiscAsQCVerified(id: $id, comment: $comment) {
      id
      miscTaskQCVerifiedDate
      miscTaskQCVerifiedComment
    }
  }
`

export default MARK_DISH_REVIEW_TASK_MISC_AS_QC_VERIFIED
